import "./table-cell-icons";



// WEBPACK FOOTER //
// ./project/client/src/core/components/wysiwyg/index.js